import { ITextField } from 'components';
import { useTranslation } from 'react-i18next';
import { InputFieldProps } from 'types';
import { useFormRules } from 'utils';

const AuthnCodeField = ({ control }: InputFieldProps) => {
	const { t } = useTranslation();
	const { formRules } = useFormRules();

	return (
		<ITextField
			control={control}
			size="small"
			name="inputCode"
			type="text"
			rules={formRules.authnCode}
			placeholder={t('product.dialog.placeholder')}
			InputLabelProps={{ shrink: false }}
		/>
	);
};

export default AuthnCodeField;
